import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-error-message',
  template: `
    @if (messages().length > 0) {
      <div
        class="rounded-2xl border px-4 py-3 text-sm"
        [class.border-rose-400/40]="tone() === 'error'"
        [class.bg-rose-500/10]="tone() === 'error'"
        [class.text-rose-100]="tone() === 'error'"
        [class.border-emerald-400/40]="tone() === 'success'"
        [class.bg-emerald-500/10]="tone() === 'success'"
        [class.text-emerald-100]="tone() === 'success'"
        [class.border-white/15]="tone() === 'info'"
        [class.bg-white/5]="tone() === 'info'"
        [class.text-white/80]="tone() === 'info'"
        [attr.aria-live]="tone() === 'error' ? 'assertive' : 'polite'"
        [attr.role]="tone() === 'error' ? 'alert' : 'status'"
        aria-atomic="true"
      >
        @if (title()) {
          <p class="font-semibold">{{ title() }}</p>
        }

        <ul class="space-y-2" [class.mt-2]="title() !== ''">
          @for (message of messages(); track message) {
            <li>{{ message }}</li>
          }
        </ul>
      </div>
    }
  `,
  host: {
    class: 'block'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorMessageComponent {
  readonly title = input('');
  readonly messages = input<string[]>([]);
  readonly tone = input<'error' | 'info' | 'success'>('error');
}